export default __webpack_public_path__ + "c94305ab68bc767c8fe8d727801254f5.webp";